import { AuthContext } from "@/providers/auth";
import { useContext } from "react";

export function useIsTextMasked() {
  const { userDetails } = useContext(AuthContext);
  return userDetails && userDetails.isJailUser && !userDetails.isJailSso;
}
